module.exports = __webpack_public_path__ + "static/media/sow-section-7-banner.85e8c76d.svg";